import { forwardRef, useState, useImperativeHandle } from "react";

const BannerAlert = forwardRef((_, ref) => {
  const [alert, setAlert] = useState(null);

  useImperativeHandle(ref, () => ({
    show(message, color = "bg-blue") {
      const id = Date.now();
      setAlert({ id, message, color });
    },
    hide() {
      setAlert(null);
    },
  }));

  if (!alert) return null;

  return (
    <div
      className={`fixed w-[100vw] z-[99] flex justify-center`}
    >
      <div
        className={`px-6 py-[6px] text-sm font-semibold text-white shadow-lg w-full flex justify-center ${alert.color}`}
        // onClick={() => setAlert(null)}
      >
        {alert.message}
      </div>
    </div>
  );
});

export default BannerAlert;